<template>
  <div>
    <zkContent leftStyle="width:30%"
               rightStyle="width:70%">
      <div slot="left">
        <el-tree :data="areas"
                 class="dept-tree-cla"
                 :default-checked-keys="defaultKey"
                 default-expand-all
                 node-key="id"
                 :highlight-current="true"
                 :expand-on-click-node="true"
                 :check-on-click-node="true">
          <div @click.stop="selectedAreaFn(data)"
               :class="{ 'custom-tree-node': true, 'leaf-node-cla': node.isLeaf }"
               slot-scope="{ node, data }">
            <span class="node-text-cla">{{ data.name }}</span>
            <zk-operate-bar :onlyIcon="true"
                            @remove="remove(data)"
                            @add="add(data)"
                            @update="update(data)"></zk-operate-bar>
          </div>
        </el-tree>
      </div>
      <div slot="right">
        <div class="header-button-bar">
          <zk-button-group :toolBar="true"
                           @add="addUser"
                           @removeUser="removeUser"></zk-button-group>
        </div>
        <zk-table :columns="userCols"
                  :data="users"
                  @selection-change="handleUserSelect"></zk-table>
      </div>
    </zkContent>
    <el-dialog :append-to-body="true"
               :title="state.title"
               :visible.sync="state.areaEditShow"
               :before-close="onCancel"
               width="40%">
      <zk-area-save-or-update ref="saveOrUpdate"
                              :form="selectedArea"
                              :isUpdate="state.isUpdate">
      </zk-area-save-or-update>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
                   @click="saveOrUpdate">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="state.title"
               :append-to-body="true"
               :visible.sync="state.userTransfer"
               width="55%"
               center>
      <zk-user-transfer :selectedData="selectedData"
                        ref="userTransfer">
      </zk-user-transfer>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="state.userTransfer = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary"
                   @click="save">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as areaService from '../../../services/area.js'
import * as userService from '../../../services/user.js'
import { dateFormat, dateByTimestamp } from '../../../utils/index.js'
export default {
  name: 'ZkArea',
  data () {
    return {
      areas: [],
      selectedUser: [],
      selectedArea: {},
      users: [],
      state: {
        areaEditShow: false,
        title: '',
        userTransfer: false
      },
      userCols: [
        {
          type: 'selection'
        },
        {
          label: this.$t('user.account'),
          prop: 'loginName',
          width: 150
        },
        {
          label: this.$t('user.userName'),
          prop: 'name'
        },
        {
          label: this.$t('user.registerTime'),
          prop: 'createTime',
          render: (h, params) => {
            return h(
              'span',
              dateFormat(dateByTimestamp(params.row.createTime), null)
            )
          }
        },
        {
          label: this.$t('user.status'),
          prop: 'status',
          render: (h, params) => {
            return h('zk-dictionary-transform', {
              props: {
                value: params.row.status,
                type: 'status'
              }
            })
          }
        }
      ],
      selectedData: []
    }
  },
  watch: {
    selectedArea () {
      this.queryUserByArea()
    }
  },
  methods: {
    queryUserByArea () {
      userService
        .queryUserByArea({
          areaId: this.selectedArea.id
        })
        .then((data) => {
          this.users = data.payload.results.userInfo
          this.selectedData = []
          this.users.forEach((item) => {
            this.selectedData.push({
              key: item.id,
              label: item.loginName
            })
          })
        })
    },
    selectedAreaFn (data) {
      this.selectedArea = data
    },
    handleUserSelect (users) {
      this.selectedUser = users
      this.selectedData = []
    },
    areaQuery (params) {
      areaService.getAllChildren(params).then((data) => {
        this.areas =
          data.payload.results.areas || data.payload.results.departments
      })
    },
    addUser () {
      if (!this.selectedArea.id) {
        this.$message({
          type: 'error',
          message: this.$t('area.selectArea')
        })
        return
      }
      this.state.title = this.$t('common.addUser')
      this.state.userTransfer = true
    },
    save () {
      let _self = this
      let val = this.$refs.userTransfer.getSelect()
      areaService
        .addUserFromArea({
          areaId: this.selectedArea.id,
          userIdArr: val
        })
        .then(() => {
          this.queryUserByArea(this.selectedArea.id)
          _self.state.userTransfer = false
          this.$message({
            type: 'success',
            message: _self.$t('common.addUserSuccess')
          })
        })
        .catch((data) => {
          _self.state.userTransfer = false
          this.$message({
            type: 'error',
            message: data.message
          })
        })
    },
    remove (data) {
      this.selectedArea = data
      this.removeArea(data)
    },
    add (data) {
      this.selectedArea = data
      this.state.areaEditShow = true
      this.state.title = this.$t('area.addArea')
      this.state.isUpdate = false
    },
    update (data) {
      this.selectedArea = data
      this.state.areaEditShow = true
      this.state.title = this.$t('area.updateArea')
      this.state.isUpdate = true
    },
    removeUser (row) {
      if (this.selectedUser.length <= 0) {
        this.$message({
          type: 'warning',
          message: this.$t('common.selectUser')
        })
        return false
      }
      this.$confirm(
        this.$t('common.confirmDeleteUserTip'),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          areaService
            .removeUserFromArea({
              areaId: this.selectedArea.id,
              userIds: this.selectedUser.map((user) => user.id)
            })
            .then(() => {
              this.queryUserByArea()
              this.$message({
                type: 'success',
                message: this.$t('common.successDelete')
              })
            })
            .catch((data) => {
              this.$message({
                type: 'error',
                message: data.message
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    saveOrUpdate () {
      let self = this
      self.$refs.saveOrUpdate
        .save()
        .then((data) => {
          if (data.code === '00000000') {
            self.areaQuery()
            self.state.areaEditShow = false
            self.$message({
              type: 'success',
              message: `${self.state.title} ` + this.$t('common.success')
            })
          } else {
            this.$message({
              type: 'error',
              message: data.message
            })
            self.state.saveOrUpdate = true
          }
        })
        .catch((data) => {
          if (data.message) {
            this.$message({
              type: 'error',
              message: data.message
            })
          }
        })
    },
    removeArea (area) {
      if (area.children && area.children.length > 0) {
        this.$message({
          type: 'error',
          message: this.$t('area.notDeleteArea')
        })
        return
      }
      if (area.id === 'root') {
        this.$message({
          type: 'error',
          message: this.$t('area.notDeleteRoot')
        })
        return
      }
      this.$confirm(
        this.$t('area.confirmDeleteAreaTip'),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          areaService
            .remove(area)
            .then(() => {
              this.$message({
                type: 'success',
                message: this.$t('common.successDelete')
              })
              this.areaQuery()
              this.queryUserByArea()
            })
            .catch((data) => {
              this.$message({
                type: 'error',
                message: data.message
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    treeRender (h, { root, node, data }) {
      let _self = this
      return h(
        'span',
        {
          style: {
            display: 'inline-block',
            width: '100%'
          },
          class: 'tree_node',
          on: {
            click: () => {
              _self.selectedArea = data
            }
          }
        },
        [
          h('span', [
            h('i', {
              attrs: {
                class: 'far fa-folder-open'
              },
              style: {
                marginRight: '8px'
              }
            }),
            h(
              'span',
              {
                style: {
                  cursor: 'pointer'
                },
                class: {
                  'el-tree-title-selected': _self.selectedArea.id === data.id
                }
              },
              [h('span', data.name)]
            )
          ]),
          h('zk-operate-bar', {
            class: 'area_btn_group_cla',
            on: {
              remove () {
                _self.removeArea(data)
              },
              add () {
                _self.state.areaEditShow = true
                _self.state.title = _self.$t('area.addArea')
                _self.state.isUpdate = false
              },
              update () {
                _self.state.areaEditShow = true
                _self.state.title = _self.$t('area.updateArea')
                _self.state.isUpdate = true
              }
            },
            props: {
              size: 'small',
              showText: false,
              params: data
            }
          })
        ]
      )
    },
    onCancel () {
      this.state.areaEditShow = false
      this.$refs.saveOrUpdate.resetFields()
      this.selectedArea = {}
    }
  },
  mounted () {
    this.areaQuery()
  }
}
</script>
<style scoped lang="less">
@import '~@/styles/var.less';
.organization {
  margin: 0px !important;
  .tree_node {
    height: 30px;
    line-height: 30px;
    position: relative;
    .area_btn_group_cla {
      position: absolute;
      right: 0px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
      .el-button {
        padding: 5px;
      }
    }
  }
  .org-container {
    padding: 8px 6px;
  }
  .el-tree-title-selected {
    color: #05203b;
  }
  // .el-tree-node__content {
  //   height: 36px;
  //   line-height: 36px;
  // }
}

@treeHeight: 44px;
/deep/ .dept-tree-cla {
  overflow: hidden;
  .custom-tree-node::before {
    position: absolute;
    top: 22px;
    content: '';
    height: 100%;
    width: 1px;
    border-left: 1px dashed rgba(0, 0, 0, 0.2);
  }
  .el-tree-node {
    position: relative;
  }
  .leaf-node-cla::before {
    display: none;
  }
  .el-tree-node__content > .el-tree-node__expand-icon {
    position: relative;
    left: 12px;
    z-index: 500;
    background-color: transparent;
    border-radius: 50%;
  }

  .el-tree-node__expand-icon.is-leaf {
    padding: 2px;
  }
  .el-tree-node__content {
    line-height: 44px;
    height: 44px;
  }

  .el-tree-node__content:hover {
    background-color: #ffffff;
  }

  .is-current {
    .el-tree-node__content {
      background-color: #ffffff;
    }
  }
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-right: 20px;
  align-items: center;
  cursor: pointer;
  z-index: 100;
  .node-text-cla {
    padding-left: 12px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
    letter-spacing: 0;
  }
  .el-button-group {
    display: none;
    align-items: center;
    /deep/.icon-btn-cla {
      color: @themeColor;
    }
  }
  &:hover {
    .node-text-cla {
      color: @themeColor;
    }
    .el-button-group {
      display: flex;
      color: @themeColor;
    }
  }
}
.leaf-node-cla {
  .node-text-cla {
    font-family: PingFangSC-Regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/area/src/main.vue